module.exports = __webpack_public_path__ + "static/media/szin.087c0605.png";